import * as React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MobileStepper from "@mui/material/MobileStepper";

import Button from "@mui/material/Button";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import { useNavigate } from "react-router-dom";
import Zoom from "react-medium-image-zoom";
import { makePostRequest, makeGetRequest } from "../../../utils/utils";
import swal from "sweetalert";
import moment from "moment";
import avtarPic from '../../../assets/Images/avtarPic.png'
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const images = [{}, {}, {}, {}];

function TicketSlider() {
  const navigate = useNavigate();

  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = images.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    // console.log('In Handle Step Change ', step)
    setActiveStep(step);
  };
  const [ticketList, setTicketList] = React.useState([]);

  async function getAllTickets() {

    setTicketList([]);

    let inputData = {
      searchString: '',
      status: false,
      sort: "newtoold",
      pageNo: 1,
      count: 3,
    };

    await makePostRequest("ticket/ticketListing", inputData)
      .then((response) => {
        // console.log('Ticket Listing ', response);
        if (response.data.status == "1") {
          const data = response.data.data.data;
          if (data.length > 0) {
            // console.log('Tickets Data ', data[0].json_agg);
            // if (data[0].json_agg) {
            setTicketList(data);
            // } else {
            //   setTicketList([]);
            // }
          } else {
            setTicketList([]);
          }
        } else {
          setTicketList([]);
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }


  function getStepContent(step) {

    return (
      <>
        <div className="requestNewInner">
          <div className="requestNewContDiv">
            <div className="requestNewContPro">
              {step.profile ?
                <Zoom>
                  <img src={step.profile} />
                </Zoom>
                :
                <Zoom>
                  <img alt="Remy Sharp" src={avtarPic} />
                </Zoom>
              }
            </div>
            <div className="requestNewContTexs">
              <h3>{step.fname} {step.lname}</h3>
              <span>{step.contact_no}</span>
              <p>{step.ticket_title}</p>
            </div>
            <div className="ticketDateTimeDiv">
              <span>{moment(step.created_at).format("DD/MM/YYYY")}</span>
              <p> {moment(step.created_at).format("h:mm:ss a")}</p>
            </div>
          </div>
        </div>
      </>
    );

  }

  function getStepContentOld(step) {
    switch (step) {
      case 0:
        return (
          <>
            <div className="requestNewInner">
              <div className="requestNewContDiv">
                <div className="requestNewContPro">
                  <Zoom>
                    <img src={ticketList[0].profile} />
                  </Zoom>
                </div>
                <div className="requestNewContTexs">
                  <h3>Riyansh Patel</h3>
                  <span>2563142563</span>
                  {/* <p>Darrell Steward</p> */}
                </div>
                <div className="ticketDateTimeDiv">
                  <span>27/06/2023</span>
                  <p>12:05:31 pm</p>
                </div>
              </div>
            </div>
          </>
        );

      case 1:
        return (
          <>
            <div className="requestNewInner">
              <div className="requestNewContDiv">
                <div className="requestNewContPro">
                  <Zoom>
                    <img src="https://i0.wp.com/mytechoffer.com/wp-content/uploads/2022/05/09b1daaf2958e78a20be454394024869-asma.jpeg?resize=700%2C769&ssl=1" />
                  </Zoom>
                </div>
                <div className="requestNewContTexs">
                  <h3>Riyansh Patel</h3>
                  <span>2563142563</span>
                  {/* <p>Darrell Steward</p> */}
                </div>
                <div className="ticketDateTimeDiv">
                  <span>27/06/2023</span>
                  <p>12:05:31 pm</p>
                </div>
              </div>
            </div>
          </>
        );
      case 2:
        return (
          <>
            <div className="requestNewInner">
              <div className="requestNewContDiv">
                <div className="requestNewContPro">
                  <Zoom>
                    <img src="https://i0.wp.com/mytechoffer.com/wp-content/uploads/2022/05/09b1daaf2958e78a20be454394024869-asma.jpeg?resize=700%2C769&ssl=1" />
                  </Zoom>
                </div>
                <div className="requestNewContTexs">
                  <h3>Riyansh Patel</h3>
                  <span>2563142563</span>
                  {/* <p>Darrell Steward</p> */}
                </div>
                <div className="ticketDateTimeDiv">
                  <span>27/06/2023</span>
                  <p>12:05:31 pm</p>
                </div>
              </div>
            </div>
          </>
        );
      case 3:
        return (
          <>
            <div className="requestNewInner">
              <div className="requestNewContDiv">
                <div className="requestNewContPro">
                  <Zoom>
                    <img src="https://i0.wp.com/mytechoffer.com/wp-content/uploads/2022/05/09b1daaf2958e78a20be454394024869-asma.jpeg?resize=700%2C769&ssl=1" />
                  </Zoom>
                </div>
                <div className="requestNewContTexs">
                  <h3>Riyansh Patel</h3>
                  <span>2563142563</span>
                  {/* <p>Darrell Steward</p> */}
                </div>
                <div className="ticketDateTimeDiv">
                  <span>27/06/2023</span>
                  <p>12:05:31 pm</p>
                </div>
              </div>
            </div>
          </>
        );

    }
  }

  React.useEffect(() => {
    getAllTickets();
  }, []);
  return (
    <>
      <div>
        <Box>
          <AutoPlaySwipeableViews
            index={activeStep}
            onChangeIndex={handleStepChange}
            enableMouseEvents
          >
            {ticketList.map((step, index) => (
              <div key={step.ticketid}>
                <form>{getStepContent(step)}</form>
                {Math.abs(activeStep - index) <= 2 ? (
                  <Box src={step.profile} alt={step.label} />
                ) : null}
              </div>
            ))}


            {/* {images.map((step, index) => (
              <div key={step.label}>
                <form>{getStepContent(activeStep)}</form>
                {Math.abs(activeStep - index) <= 2 ? (
                  <Box src={step.imgPath} alt={step.label} />
                ) : null}
              </div>
            ))} */}
          </AutoPlaySwipeableViews>
          <MobileStepper
            steps={maxSteps}
            position="static"
            activeStep={activeStep}
            nextButton={
              <Button
                size="small"
                onClick={handleNext}
                disabled={activeStep === maxSteps - 1}
              >
                Next
                {theme.direction === "rtl" ? (
                  <KeyboardArrowLeft />
                ) : (
                  <KeyboardArrowRight />
                )}
              </Button>
            }
            backButton={
              <Button
                size="small"
                onClick={handleBack}
                disabled={activeStep === 0}
              >
                {theme.direction === "rtl" ? (
                  <KeyboardArrowRight />
                ) : (
                  <KeyboardArrowLeft />
                )}
                Back
              </Button>
            }
          />
        </Box>
      </div>
    </>
  );
}

export default TicketSlider;
